module.exports = __webpack_public_path__ + "img/mapaCamadas.f307b01a.svg";